import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { CloseDialog, OpenDialog } from './report.actions';
import { ReportDialogState } from './report.state';

@Injectable({
  providedIn: 'root'
})
export class ReportDialogFacade {
  private readonly store = inject(Store);

  @Select(ReportDialogState.open) open$: Observable<boolean>;

  openDialog() {
    this.store.dispatch(new OpenDialog());
  }

  closeDialog() {
    this.store.dispatch(new CloseDialog());
  }
}
